import React, { useState } from "react";
import { api, formatApiError } from "../lib/api";
import { Send, CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function InviaPianificazioneButton({ cid, flusso, onSaved }) {
  const [saving, setSaving] = useState(false);
  const sent = flusso === "da_pianificare";

  const send = async () => {
    setSaving(true);
    try {
      await api.post(`/clienti/${cid}/installazione/invia-pianificazione`);
      toast.success("Inviato in Installazioni da Pianificare");
      onSaved?.();
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setSaving(false); }
  };

  return (
    <div className="card-shell p-4 flex flex-wrap items-center gap-3" data-testid="invia-pianificazione-block">
      <button onClick={send} disabled={saving || sent}
        className={`text-sm ${sent ? "btn-secondary" : "btn-primary"} disabled:opacity-60`}
        data-testid="invia-pianificazione-btn">
        {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : sent ? <CheckCircle2 className="w-4 h-4" /> : <Send className="w-4 h-4" />}
        {sent ? "Già in Installazioni da Pianificare" : "Invia in Installazioni da Pianificare"}
      </button>
      <span className="text-xs flex-1 min-w-[200px]" style={{ color: "var(--text-muted)" }}>
        Il cliente comparirà nella lista "Installazioni da Pianificare".
      </span>
    </div>
  );
}
